const OUR_LIVE_SOLUTIONS = [
  {
    num: '01',
    icon: 'fas fa-server',
    label: 'Web Infrastructure',
    name: 'Salama Hosting',
    tagline: '200+ businesses online. None of them thinking about servers.',
    description:
      "We host over 200 businesses across Uganda — managed environments, business email, domain registration, and billing straight through MTN Mobile Money. No international card required, no support tickets that vanish, no 2am outages with no one to call. Everything just works.",
    features: [
      'cPanel & Plesk managed environments',
      'Domain registration and DNS management',
      'Business email hosting',
      'MTN Mobile Money billing',
      'SSL certificates and 24/7 uptime monitoring',
    ],
    sectors: ['SMEs', 'NGOs', 'Startups'],
    liveUrl: 'https://salamahosting.com',
    liveLabel: 'Visit Platform',
    ctaLabel: 'Request Hosting',
    ctaTo: '/contact',
  },
  {
    num: '02',
    icon: 'fas fa-shield-halved',
    label: 'Financial Services',
    name: 'Insurance Broker System',
    tagline: 'Every policy. Every claim. Every IRA report. One system.',
    description:
      "Ugandan insurance brokers have been patching together spreadsheets and manual processes for too long. InsurBMS brings it all under one roof — policy lifecycle, claims tracking, commission calculations, renewal alerts, and the regulatory reports IRA actually asks for. Built from conversations with real brokers, not assumptions.",
    features: [
      'IRA-compliant regulatory reporting',
      'Full policy lifecycle and renewal management',
      'Claims processing and status tracking',
      'Automated commission calculation',
      'Renewal alerts before they lapse',
    ],
    sectors: ['Insurance Brokers', 'Financial Services'],
    liveUrl: 'https://insurbms.salamasystems.com',
    liveLabel: 'View Live',
    ctaLabel: 'Request a Demo',
    ctaTo: '/contact',
  },
  {
    num: '03',
    icon: 'fas fa-cubes',
    label: 'Operations',
    name: 'Asset Management System',
    tagline: 'Assets go missing quietly. Now you\'ll know before the audit.',
    description:
      "Physical assets disappear from organisations slowly — a laptop here, equipment there — and nobody notices until the external auditors ask. Our ASM tracks every asset from purchase order to disposal with QR labels, depreciation schedules, maintenance history, and an audit trail that holds up under real scrutiny.",
    features: [
      'Asset registration and QR labelling',
      'Procurement and acquisition tracking',
      'Depreciation schedules and financial reporting',
      'Maintenance history and scheduling',
      'Full disposal workflow with audit trail',
    ],
    sectors: ['Government', 'NGOs', 'Corporate'],
    liveUrl: 'https://asm.salamasystems.com',
    liveLabel: 'View Live',
    ctaLabel: 'Request a Demo',
    ctaTo: '/contact',
  },

  {
    num: '04',
    icon: 'fas fa-chalkboard-user',
    label: 'Education',
    name: 'School Management System',
    tagline: 'Built for Ugandan schools. Not a template from somewhere else.',
    description:
      "Ugandan schools run on UNEB exam schedules, term fees, SMS notices to parents, and timetables that shift every term. SchoolSphere was designed around that reality — not adapted from a European SIS that doesn't understand how things work here. From enrolment to exam registration, it fits.",
    features: [
      'Student enrolment and academic records',
      'Uganda curriculum timetabling',
      'Fees billing, payments, and receipts',
      'Parent communication and notice board',
      'UNEB exam registration workflow',
    ],
    sectors: ['Primary', 'Secondary', 'Tertiary'],
    liveUrl: 'https://schoolsphere.salamasystems.com/',
    liveLabel: 'View Live',
    ctaLabel: 'Enquire Now',
    ctaTo: '/contact',
  },
  {
    num: '05',
    icon: 'fas fa-boxes-stacked',
    label: 'Supply Chain & Retail',
    name: 'Inventory Management System',
    tagline: 'Stop finding out you\'ve run out after a customer already asked.',
    description:
      "Shrinkage, stockouts, and zero visibility across your locations — all fixable. Inventa tracks stock in real time at every site, fires low-stock alerts before you run dry, and gives you the purchase order and supplier tools to close the gap before it costs you. Most clients notice the difference within the first few weeks.",
    features: [
      'Real-time stock tracking across locations',
      'Purchase orders and supplier management',
      'Low-stock alerts and automatic reorder triggers',
      'Sales order fulfilment and dispatch',
      'Inventory valuation and shrinkage reports',
    ],
    sectors: ['Retail', 'Wholesale', 'NGOs'],
    liveUrl: 'https://inventa.salamasystems.com/',
    liveLabel: 'View Live',
    ctaLabel: 'Request a Demo',
    ctaTo: '/contact',
  },
  {
    num: '06',
    icon: 'fas fa-building',
    label: 'Real Estate & Property',
    name: 'Kazi Kings, Property Listing and Rent Management Platform',
    tagline: 'Your tenants pay. Your records are clean. You sleep better.',
    description:
      "Managing rental properties in a spreadsheet works until you have more than three tenants, a maintenance backlog, and late payments you can't track. Rentlar handles onboarding, lease agreements, automated rent invoices, maintenance requests, and the financial reporting your accountant actually wants — whether you have one property or fifteen.",
    features: [
      'Tenant onboarding and lease management',
      'Automated rent invoicing and receipts',
      'Maintenance request tracking and status',
      'Vacancy management and listing tools',
      'Landlord financial reporting by property',
    ],
    sectors: ['Landlords', 'Property Agents'],
    liveUrl: 'https://kazikings.com',
    liveLabel: 'View Live',
    ctaLabel: 'Request a Demo',
    ctaTo: '/contact',
  },
]

const STEPS = [
  {
    icon: 'fas fa-clipboard-list',
    num: 1,
    title: 'We ask a lot of questions first',
    body: 'Before we open a code editor, we want to understand the problem from your side — what\'s actually broken, what the constraints are, and what a good outcome looks like. It slows things down upfront and saves months later.',
  },
  {
    icon: 'fas fa-drafting-compass',
    num: 2,
    title: 'Then we design something worth building',
    body: 'Data model, architecture, integration points — all mapped before we write a line of code. No surprises halfway through.',
  },
  {
    icon: 'fas fa-cogs',
    num: 3,
    title: 'We build in phases, not big-bang deliveries',
    body: 'You see working software at each stage and give feedback before we move forward. Nothing disappears for three months and comes back as something you didn\'t ask for.',
  },
  {
    icon: 'fas fa-rocket',
    num: 4,
    title: 'We ship — then we stick around',
    body: 'Go-live is the beginning, not the finish line. We train your team, handle the first wave of real-world issues, and stay available as long as the system is running.',
  },
]

const HOW_WE_WORK = [
  {
    icon: 'fas fa-clipboard-list',
    title: 'We start with the problem, not a solution',
    body: 'Half the projects we\'ve seen go wrong started with a technology decision made before anyone understood what actually needed to change. We ask questions first. Every time.',
  },
  {
    icon: 'fas fa-drafting-compass',
    title: 'Design before build — no exceptions',
    body: 'Architecture, data models, integrations — mapped before we touch the code. It\'s slower to start and significantly faster to finish.',
  },
  {
    icon: 'fas fa-shield-halved',
    title: 'Security goes into the spec, not the punch list',
    body: 'Role-based access, encryption, audit logging — these appear in the design spec before we write the first line. Not added at the end if there\'s budget left.',
  },
  {
    icon: 'fas fa-expand-arrows-alt',
    title: 'We build for the scale you\'ll actually reach',
    body: 'Systems that need replacing after two years of growth weren\'t built right. We think about where you\'re going, not just where you are now.',
  },
  {
    icon: 'fas fa-chalkboard-user',
    title: 'Your team should run this without us',
    body: 'We train your people properly and write documentation they\'ll actually use. Independence from us is the goal. Dependency is not a business model we want.',
  },
  {
    icon: 'fas fa-headset',
    title: 'We\'re still here after go-live',
    body: 'Real usage uncovers things no amount of testing does. We stay involved for updates, performance monitoring, and support — for as long as the system is in use.',
  },
]

const WHAT_WE_STAND_FOR = [
  {
    title: 'Reliability',
    body: 'These systems run organisations every day. When they go down, work stops. We treat uptime and data integrity as the floor, not a selling point.',
  },
  {
    title: 'Discretion',
    body: 'We work with organisations that handle sensitive information. What we build for a client stays between us — no referencing client work without explicit permission.',
  },
  {
    title: 'Accountability',
    body: "If something we built isn't working right, we fix it. No deflection, no renegotiation. That's the whole policy.",
  },
  {
    title: 'Playing the long game',
    body: "Our best client relationships have outlasted the original project by years. We're not interested in quick work — we're interested in systems still running well five years from now.",
  },
]

const OUR_SERVICES = [
  {
    icon: 'fas fa-code',
    title: 'Software Development',
    desc: 'Custom business software built around your workflows — not a template that sort of fits.',
  },
  {
    icon: 'fas fa-mobile-alt',
    title: 'Mobile App Development',
    desc: 'iOS and Android apps with Mobile Money integrations and offline support built in.',
  },
  {
    icon: 'fas fa-cubes',
    title: 'System Development',
    desc: 'Enterprise systems for complex operations — with the audit trails institutions require.',
  },
  {
    icon: 'fas fa-server',
    title: 'Web Hosting',
    desc: 'Managed hosting for 200+ businesses. Fast servers, 24/7 monitoring, MTN billing.',
  },
  {
    icon: 'fas fa-globe',
    title: 'Domain Registration',
    desc: '.com, .co.ug, .ug and 50+ extensions. DNS management and renewals handled for you.',
  },
  {
    icon: 'fas fa-paint-brush',
    title: 'Website Designing',
    desc: 'Fast, mobile-first corporate and e-commerce sites designed to convert visitors.',
  },
]

const WHY_WORK_WITH_US = [
  {
    icon: 'fas fa-chart-line',
    title: 'We build systems that drive real business growth',
    body: 'Our solutions are designed to increase efficiency, automate operations, and help organizations scale faster with technology that delivers measurable impact.',
  },
  {
    icon: 'fas fa-lock',
    title: 'Security and reliability come first',
    body: 'We develop secure, stable, and dependable platforms with protected data access, modern security practices, and systems businesses can trust every day.',
  },
  {
    icon: 'fas fa-globe-africa',
    title: 'Built for Uganda and East African businesses',
    body: 'From mobile money integrations to local operational realities, we create systems tailored to how organizations across the region actually work.',
  },
  {
    icon: 'fas fa-headset',
    title: 'Long-term support you can depend on',
    body: 'We don’t disappear after deployment. Our team provides ongoing support, updates, maintenance, and technical guidance to keep your systems running smoothly.',
  },
]
const INDUSTRIES = [
  { icon: 'fas fa-landmark', title: 'Government' },
  { icon: 'fas fa-hands-helping', title: 'NGOs & Development' },
  { icon: 'fas fa-university', title: 'Financial Services' },
  { icon: 'fas fa-plane-departure', title: 'Tourism & Hospitality' },
  { icon: 'fas fa-building', title: 'Private Sector' },
]

const INDUSTRIES_DETAILED = [
  {
    icon: 'fas fa-landmark',
    title: 'Government',
    description:
      "We've built platforms for government agencies that need to work under real-world scrutiny — not just demo well. Case management, records, M&E, regulatory reporting. In the public sector, security and audit trails aren't optional, and we don't treat them like they are.",
    capabilities: [
      'Case and information management',
      'Records management and digital archival',
      'Monitoring and evaluation platforms',
      'Compliance reporting and audit trails',
      'Role-based access and data protection',
    ],
    sidebarIcon: 'fas fa-shield-halved',
    sidebarTitle: 'Security built in from day one',
    sidebarBody:
      'Government systems sit at the intersection of sensitive data and public accountability. We build with that in mind — encryption, granular access controls, and audit logs that give you an accurate record of every action. Not because it\'s required. Because it should be.',
  },
  {
    icon: 'fas fa-hands-helping',
    title: 'NGOs & Development Organisations',
    description:
      "NGOs need to track what's working, report accurately to donors, and collect data in the field — often with a team that's stretched thin and a connection that cuts out. We've built M&E platforms and field data tools for those conditions, not for an office with reliable internet.",
    capabilities: [
      'Monitoring and evaluation (M&E) systems',
      'Programme and project management',
      'Field data collection (online and offline)',
      'Donor reporting and dashboards',
      'Beneficiary tracking and impact measurement',
    ],
    sidebarIcon: 'fas fa-chart-line',
    sidebarTitle: 'Donor reports without the marathon',
    sidebarBody:
      'Quarterly reporting takes real time away from the work. Our M&E platforms automate collection, aggregation, and formatting — so your team can produce an accurate report in a morning instead of a week.',
    reverse: true,
  },
  {
    icon: 'fas fa-university',
    title: 'Financial Services',
    description:
      "Financial institutions and insurance companies operate in environments where a compliance gap is never just an inconvenience. We build systems that handle sensitive financial data correctly — from policy and claims to regulatory reporting that actually satisfies an IRA audit.",
    capabilities: [
      'Policy and claims management',
      'Financial transaction platforms',
      'Regulatory compliance reporting',
      'Secure data processing and encryption',
      'Audit trail and accountability systems',
    ],
    sidebarIcon: 'fas fa-lock',
    sidebarTitle: 'Compliance built into the architecture',
    sidebarBody:
      "Compliance in financial services isn't a checklist item — it's the baseline. We design systems around the specific regulatory requirements of the markets we work in, including IRA compliance for insurance brokers in Uganda.",
  },

  {
    icon: 'fas fa-building',
    title: 'Private Sector',
    description:
      "Most businesses in Uganda are still running on manual processes or software they've long outgrown. We help them move to systems that fit how their organisation actually operates — built for the scale they need now and designed to handle growth without being replaced.",
    capabilities: [
      'Custom business management systems',
      'Document and records management',
      'Workflow automation and digitisation',
      'Enterprise application development',
      'IT consulting and roadmap planning',
    ],
    sidebarIcon: 'fas fa-expand-arrows-alt',
    sidebarTitle: 'Built to grow with you',
    sidebarBody:
      "We've watched too many businesses rebuild their systems from scratch because no one thought about growth at the start. We design for where you're going — not just where you are today.",
  },
]

const SERVICES_DETAILED = [
  {
    icon: 'fas fa-code',
    title: 'Software Development',
    description:
      'Custom software built around how your business actually works — not a template that sort of fits. From standalone desktop tools to complex multi-user platforms, we design, build, and maintain software that does the job properly.',
    capabilities: [
      'Custom business applications and ERP systems',
      'CRM and workflow management platforms',
      'API design and third-party system integrations',
      'QA, testing, and automated deployment pipelines',
      'Ongoing maintenance and iterative feature development',
    ],
  },
  {
    icon: 'fas fa-mobile-alt',
    title: 'Mobile App Development',
    description:
      'iOS and Android apps built for the way people in East Africa actually use their phones — Mobile Money integrations, low-bandwidth connections, and offline support included. Native feel, cross-platform efficiency.',
    capabilities: [
      'iOS and Android native application development',
      'Cross-platform apps with React Native',
      'MTN and Airtel Mobile Money integrations',
      'Offline-first and low-bandwidth architecture',
      'Play Store and App Store submission and deployment',
    ],
  },
  {
    icon: 'fas fa-cubes',
    title: 'System Development',
    description:
      'Enterprise systems for organisations that need more than off-the-shelf software can offer. Case management, records systems, M&E platforms, insurance systems — built to handle real-world complexity with the security and audit trails institutions require.',
    capabilities: [
      'Case and document management systems',
      'Monitoring and evaluation (M&E) platforms',
      'Records management and digital archival systems',
      'Insurance and financial management platforms',
      'Role-based access, compliance reporting, and audit trails',
    ],
  },
  {
    icon: 'fas fa-server',
    title: 'Web Hosting',
    description:
      'Managed hosting for over 200 businesses across Uganda. Fast servers, 24/7 uptime monitoring, cPanel control panels, and billing straight through MTN Mobile Money — no international card required, no 2am outages with no one to call.',
    capabilities: [
      'Managed cPanel and Plesk hosting environments',
      'SSL certificates and 24/7 uptime monitoring',
      'Business email hosting and configuration',
      'MTN Mobile Money billing (no international card needed)',
      'Daily backups and proactive security hardening',
    ],
  },
  {
    icon: 'fas fa-globe',
    title: 'Domain Registration',
    description:
      'Register and manage your domain names across all major extensions — .com, .co.ug, .ug, .org, and 50+ more. We handle DNS configuration, renewals, and transfers so your online presence stays secure and uninterrupted.',
    capabilities: [
      '.com, .co.ug, .ug, .org and 50+ domain extensions',
      'DNS management and zone configuration',
      'Domain transfers, migrations, and consolidation',
      'WHOIS privacy protection',
      'Renewal reminders and auto-renewal management',
    ],
  },
  {
    icon: 'fas fa-paint-brush',
    title: 'Website Designing',
    description:
      'Corporate websites, landing pages, tourism booking sites, and e-commerce stores — designed to be fast, mobile-first, and built to convert visitors into customers. A website that looks good but does nothing is just an expense.',
    capabilities: [
      'Corporate, NGO, and organisation websites',
      'Landing pages and product marketing sites',
      'E-commerce stores and online booking platforms',
      'SEO and Core Web Vitals performance optimisation',
      'CMS integration for easy self-managed content',
    ],
  },
]

const SERVICES_SPECIALISED = [
  {
    icon: 'fas fa-folder-open',
    title: 'Case Management',
    description:
      'Single place to register, track, escalate, and close cases — with a full audit trail and reporting that shows where everything stands.',
    capabilities: [
      'Workflow-driven case registration and tracking',
      'SLA enforcement and automatic escalations',
      'Full audit trail for compliance',
    ],
  },
  {
    icon: 'fas fa-file-lines',
    title: 'Document Management',
    description:
      'Centralised repository with version control, access controls, and full-text search. The right file, accessible to the right person, every time.',
    capabilities: [
      'Version control and change history',
      'Encrypted storage and access controls',
      'Full-text search and metadata tagging',
    ],
  },
  {
    icon: 'fas fa-database',
    title: 'Records Management',
    description:
      'Compliance from creation to disposal. Classification, retention schedules, and disposal rules enforced so you\'re always audit-ready.',
    capabilities: [
      'Classification and retention scheduling',
      'Regulatory compliance enforcement',
      'Controlled disposal workflows',
    ],
  },
  {
    icon: 'fas fa-chart-bar',
    title: 'Monitoring & Evaluation',
    description:
      'Track indicators automatically, collect field data online and offline, and generate formatted donor reports on demand — not in a week of spreadsheet work.',
    capabilities: [
      'Indicator and target tracking dashboards',
      'Field data collection (online and offline)',
      'Automated donor report generation',
    ],
  },
  {
    icon: 'fas fa-chalkboard-user',
    title: 'Training & Knowledge Transfer',
    description:
      'We train every user until they\'re genuinely independent. Admin and end-user sessions, documentation, and post-training support included.',
    capabilities: [
      'End-user and administrator training',
      'Technical documentation and user manuals',
      'Knowledge transfer workshops',
    ],
  },
  {
    icon: 'fas fa-lightbulb',
    title: 'IT Consulting',
    description:
      'Honest advice on what to build, what to buy, and what to leave alone — without the vendor bias that tends to come with other kinds of consulting.',
    capabilities: [
      'IT strategy and technology roadmap planning',
      'Systems architecture and vendor evaluation',
      'Digital transformation advisory',
    ],
  },
]

const SERVICE_SUMMARY = [
  'Software Development',
  'Mobile App Development',
  'System Development',
  'Web Hosting',
  'Domain Registration',
  'Website Designing',
  'Other / Not Sure Yet',
]

const OUR_PARTNERS = [
  { icon: 'fas fa-landmark', label: 'Government Agencies' },
  { icon: 'fas fa-hands-helping', label: 'NGOs & Development' },
  { icon: 'fas fa-university', label: 'Financial Services' },
  { icon: 'fas fa-plane-departure', label: 'Tourism & Hospitality' },
  { icon: 'fas fa-building', label: 'Private Enterprises' },
  { icon: 'fas fa-chalkboard', label: 'Schools & Institutions' },
  { icon: 'fas fa-hospital', label: 'Health Organisations' },
  { icon: 'fas fa-warehouse', label: 'Retail & Distribution' },
]

const LIVE_PLATFORMS_SUMMARY = [
  { value: '20+',  label: 'Platforms Deployed' },
  { value: '4',    label: 'Countries' },
  { value: '7',    label: 'Industries Served' },
  { value: '200+', label: 'Active Clients' },
]

const TECHSTACK = [
  { icon: 'devicon-php-plain colored', name: 'PHP' },
  { icon: 'devicon-wordpress-plain colored', name: 'WordPress' },
  { icon: 'devicon-laravel-plain colored', name: 'Laravel' },
  { icon: 'devicon-react-original colored', name: 'React' },
  { icon: 'devicon-vuejs-plain colored', name: 'Vue.js' },
  { icon: 'devicon-symfony-original colored', name: 'Symfony' },
  { icon: 'devicon-angularjs-plain colored', name: 'Angular' },
  { icon: 'devicon-nodejs-plain colored', name: 'Node.js' },
  { icon: 'devicon-express-original colored', name: 'Express.js' },
  { icon: 'devicon-react-original colored', name: 'React Native' },
  { icon: 'devicon-nextjs-original colored', name: 'Next.js' },
  { icon: 'devicon-nuxtjs-plain colored', name: 'Nuxt.js' },
  { icon: 'devicon-typescript-plain colored', name: 'TypeScript' },
  { icon: 'devicon-mysql-plain colored', name: 'MySQL' },
  { icon: 'devicon-postgresql-plain colored', name: 'PostgreSQL' },
]

export {
  OUR_LIVE_SOLUTIONS,
  SERVICES_DETAILED,
  SERVICES_SPECIALISED,
  SERVICE_SUMMARY,
  STEPS,
  OUR_PARTNERS,
  HOW_WE_WORK,
  WHAT_WE_STAND_FOR,
  OUR_SERVICES,
  INDUSTRIES,
  INDUSTRIES_DETAILED,
  TECHSTACK,
  LIVE_PLATFORMS_SUMMARY,
  WHY_WORK_WITH_US,
}
